import {Tabs} from 'antd'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useContext} from 'react'
import {NullAsDefault} from "../../views/Shared";
import {LayoutContext} from "../layouts/Default/LayoutContext";
import classNames from "classnames";

export const ActionModalWrapper = ({
                                       tab,
                                       tabs,
                                       style,
                                       className,
                                       children,
                                       action = null,
                                       onTabChange = NullAsDefault,
                                   }) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)
    const renderTabs = useCallback(
        (children) => (
            <Tabs
                className={!isSm && "custom-tabs-edit py-3"}
                centered={isSm}
                tabBarGutter={isSm ? 16 : 8}
                tabPosition={isSm ? "top" : "left"}
                onChange={onTabChange}
                tabBarStyle={{width: !isSm && 180}}
                items={Array.from(tabs ?? []).map(
                    ({key, label, component: Component = NullAsDefault}) => ({
                        key,
                        label: t(label),
                        children: (
                            <div className="flex flex-col w-full gap-4 py-3">
                                <Component child={children}/>
                            </div>
                        ),
                    })
                )}
            />
        ),
        [tab, tabs]
    );

    return (
        <div
            style={style}
            className={classNames('flex flex-col gap-3', className)}>
            {tab ? renderTabs(children) : children}
            {action}
        </div>
    )
}

